// Legacy individual icon exports (keep for backward compatibility)
export { default as IconWarning } from './IconWarning'
export { default as IconFacebook } from './IconFacebook'
export { default as IconGoogle } from './IconGoogle'
export { default as IconLinkedin } from './IconLinkedin'

// New unified icon system exports
export { Icon } from './Icon'
export { iconRegistry, addIcon, getAvailableIcons } from './IconRegistry'
export type { IconName, IconData } from './IconRegistry'
export { 
  svgStringToIconData, 
  addIconFromSvg, 
  generateIconCode, 
  batchGenerateIconCode,
  IconSizes,
  IconColors
} from './IconUtils'
export type { IconSize, IconColor } from './IconUtils'
